import React, { Component } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import TldrBase from "../TldrLogin/TldrBase";
import { withRouter, Redirect } from "react-router-dom";
import { GoogleLogin } from "react-google-login";
import { GOOGLE_CLIENT_ID, INVITATIONS } from "../_actions/endpoints";
import { Link as RouterLink } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import { connect } from "react-redux";
import * as yup from "yup";
import { SET_NEW_PASSWORD_VIA_INVITATION } from "../_actions/endpoints";

import {
  PASSWORD_SET_SUCCESS_VIA_INVITATION,
  PASSWORD_SET_FAILURE_VIA_INVITATION,
  LOGIN,
} from "../_utils/routes";
import { loginWithGoogle } from "../_actions/authActions";
import { ROOT } from "../_utils/routes";
import Format from "string-format";
import { ShowCenterSpinner } from "../_components/common/statelessView";
import { FaArrowLeft } from "react-icons/fa";
import {
  Box,
  Button,
  Divider,
  Flex,
  FormControl,
  FormErrorMessage,
  Heading,
  Icon,
  Input,
  Link,
} from "@chakra-ui/react";
import { withTranslation, useTranslation } from "react-i18next";

const validationSchema = (t) =>
  yup.object({
    first_name: yup
      .string()
      .required(t("set_password_invitation.first_name_error")),
    last_name: yup
      .string()
      .required(t("set_password_invitation.last_name_error")),
    password: yup
      .string()
      .min(8, t("set_password_invitation.password_min"))
      .required(t("set_password_invitation.password_required")),
  });

const googleResponse = (response, props) => {
  var invitationToken = props.match.params.token;
  const tokenJSON = {
    access_token: response.accessToken,
    invite_token: invitationToken,
  };
  props.loginWithGoogle(tokenJSON, props, "accepetedInvite");
};

const onFailure = (error) => {};

const SetPasswordViaInvitationForm = ({ data, props }) => {
  const { t } = useTranslation(["auth"]);
  return (
    <Formik
      initialValues={{
        email: data.email,
        first_name: data.first_name,
        last_name: data.last_name,
        password: "",
      }}
      validationSchema={validationSchema(t)}
      onSubmit={(values, { setSubmitting, setErrors, resetForm }) => {
        var userData = {
          first_name: values.first_name,
          last_name: values.last_name,
          password: values.password,
        };
        axios
          .post(
            SET_NEW_PASSWORD_VIA_INVITATION + `/${props.match.params.token}/`,
            userData
          )
          .then((res) => {
            setSubmitting(false);
            resetForm({ values: "" });
            props.history.push(PASSWORD_SET_SUCCESS_VIA_INVITATION);
          })
          .catch((error) => {
            setSubmitting(false);
            props.history.push(PASSWORD_SET_FAILURE_VIA_INVITATION);
          });
      }}
    >
      {({ isSubmitting, isValid, values }) => (
        <>
          <TldrBase
            showBackgroundImage
            heading={t("set_password_invitation.heading")}
            subheading={t("set_password_invitation.subheading")}
          >
            <Box className="row social-buttons" my={2}>
              <GoogleLogin
                buttonText={t("set_password_invitation.google.btn_text")}
                clientId={GOOGLE_CLIENT_ID}
                onSuccess={(response) => googleResponse(response, props)}
                onFailure={onFailure}
                className="social-btn-google"
                cookiePolicy={"single_host_origin"}
                theme="dark"
              />
            </Box>
            <Divider />
            {/* <div className="input-group mb-3 center">
            Please create your password.
          </div> */}
            <Form>
              <Field name="email">
                {({ field }) => (
                  <FormControl mt={2}>
                    <Input
                      size={"lg"}
                      fontSize="inherit"
                      {...field}
                      readOnly
                      type="email"
                      name="email"
                      placeholder={t("set_password_invitation.email")}
                    />
                  </FormControl>
                )}
              </Field>
              <Field name="first_name">
                {({ field, form }) => (
                  <FormControl
                    mt={3}
                    isInvalid={
                      form.errors.first_name && form.touched.first_name
                    }
                  >
                    <Input
                      size={"lg"}
                      fontSize="inherit"
                      {...field}
                      type="text"
                      name="first_name"
                      placeholder={t("set_password_invitation.first_name")}
                    />
                    <FormErrorMessage>
                      {form.errors.first_name}
                    </FormErrorMessage>
                  </FormControl>
                )}
              </Field>
              <Field name="last_name">
                {({ field, form }) => (
                  <FormControl
                    mt={3}
                    isInvalid={form.errors.last_name && form.touched.last_name}
                  >
                    <Input
                      size={"lg"}
                      fontSize="inherit"
                      {...field}
                      type="text"
                      name="last_name"
                      placeholder={t("set_password_invitation.last_name")}
                    />
                    <FormErrorMessage>{form.errors.last_name}</FormErrorMessage>
                  </FormControl>
                )}
              </Field>
              <Field name="password">
                {({ field, form }) => (
                  <FormControl
                    mt={3}
                    isInvalid={form.errors.password && form.touched.password}
                  >
                    <Input
                      size={"lg"}
                      fontSize="inherit"
                      {...field}
                      type="password"
                      name="password"
                      placeholder={t("set_password_invitation.password")}
                    />
                    <FormErrorMessage>{form.errors.password}</FormErrorMessage>
                  </FormControl>
                )}
              </Field>
              <Button
                type="submit"
                float="right"
                my={3}
                size="lg"
                disabled={values.first_name === "" || !isValid}
                isLoading={isSubmitting}
              >
                {t("set_password_invitation.signup")}
              </Button>
            </Form>
            <Flex mt={3} justify={"flex-end"}>
              <label>
                {t("set_password_invitation.tnc_1")}{" "}
                <Link as={RouterLink} to="/register">
                  {t("set_password_invitation.tnc_2")}
                </Link>
              </label>
            </Flex>
          </TldrBase>
          <Box mt={3} className="copyright">
            <div>
              {t("login.copyright", { year: new Date().getFullYear() })}
            </div>
          </Box>
        </>
      )}
    </Formik>
  );
};
class SetPasswordViaInvitation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      error: "",
      data: {},
    };
  }

  componentDidMount() {
    const {
      params: { token },
    } = this.props.match;

    axios
      .get(Format(INVITATIONS, token))
      .then((res) => {
        this.setState({
          loaded: true,
          token: token,
          data: res.data,
        });
      })
      .catch((error) => {
        this.setState({
          loaded: true,
          error: this.props.t("set_password_invitation.error"),
        });
      });
  }

  render() {
    const { t } = this.props;
    const { loaded, error, data } = this.state;

    if (this.props.auth.isAuthenticated) {
      return <Redirect to={ROOT} />;
    }
    return (
      <>
        {loaded && error ? (
          <TldrBase>
            <Heading as="h2" textAlign="center">
              {t("set_password_invitation.heading")}
            </Heading>
            <Box textAlign="center">{error}</Box>
            <Box className="secondary-links" textAlign="center" mt={2}>
              <Link to={LOGIN}>
                <Icon as={FaArrowLeft} mr={1} />
                {t("set_password_invitation.back")}
              </Link>
            </Box>
          </TldrBase>
        ) : loaded ? (
          <SetPasswordViaInvitationForm
            data={data}
            props={this.props}
          ></SetPasswordViaInvitationForm>
        ) : (
          <ShowCenterSpinner loaded={loaded}></ShowCenterSpinner>
        )}
      </>
    );
  }
}

SetPasswordViaInvitation.prototypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});

const mapDispatchToProps = (dispatch) => ({
  loginWithGoogle: (token, props, action) =>
    dispatch(loginWithGoogle(token, props, action)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation(["auth"])(SetPasswordViaInvitation)));
